import axios from "../api/axios";
import { useQuery } from "@tanstack/react-query";
import { endpoints } from "../api/endpoint";

// const emiAdminConfig = {
//   minCIBIL: 500,
//   tenures: [12],
//   batteryTypes: ["52.2V/100AH Livguard"],
//   downPayment: { min: 7500, max: 40000, step: 500 },
//   updatedAt: { _seconds: 1772012864, _nanoseconds: 237000000 },
//   financiers: {
//     LTO_LOW: {
//       insuranceRate: 0.015,
//       stampDuty: 0,
//       loanSuraksha: 0,
//       eligibility: {
//         maxCIBIL: 659,
//         downPayment: { max: 40000, min: 12500 },
//         cities: ["JAIPUR", "KHATU"],
//       },
//       gstOnProcessingFeeRate: 0,
//       processingFeeRate: 0,
//       interestRate: 0.45,
//       gstOnInsuranceRate: 0.18,
//       eMandateCharge: 0,
//       invoiceCalculation: "DIRECT",
//       targetNetBank: 67440,
//     },
//     LTO_HIGH: {
//       targetNetBank: 67440,
//       invoiceCalculation: "DIRECT",
//       gstOnInsuranceRate: 0.18,
//       interestRate: 0.3,
//       eMandateCharge: 0,
//       processingFeeRate: 0,
//       loanSuraksha: 0,
//       eligibility: {
//         minCIBIL: 660,
//         downPayment: { max: 40000, min: 16500 },
//         cities: [
//           "INDORE",
//           "UJJAIN",
//           "BHOPAL",
//           "GWALIOR",
//           "JAIPUR",
//           "KHATU",
//           "GURGAON",
//           "DABRA",
//           "SHIVPURI",
//           "FARIDABAD",
//           "DEWAS",
//         ],
//       },
//       gstOnProcessingFeeRate: 0,
//       insuranceRate: 0.015,
//       stampDuty: 0,
//     },
//     MOOVING: {
//       stampDuty: 0,
//       insuranceRate: 0,
//       gstOnProcessingFeeRate: 0,
//       loanSuraksha: 0,
//       eligibility: {
//         maxCIBIL: 659,
//         downPayment: { min: 12000, max: 12000 },
//         cities: ["INDORE", "UJJAIN", "BHOPAL", "GWALIOR"],
//       },
//       processingFeeRate: 0,
//       eMandateCharge: 0,
//       interestRate: 0.4255,
//       gstOnInsuranceRate: 0,
//       invoiceCalculation: "DIRECT",
//       targetNetBank: 61145,
//     },
//     AMU: {
//       eligibility: {
//         cities: [
//           "INDORE",
//           "UJJAIN",
//           "BHOPAL",
//           "JAIPUR",
//           "GWALIOR",
//           "KHATU",
//           "GURGAON",
//           "DABRA",
//           "SHIVPURI",
//           "FARIDABAD",
//           "DEWAS",
//         ],
//         downPayment: { max: 16000, min: 8500 },
//         minCIBIL: 660,
//       },
//       loanSuraksha: 850,
//       gstOnProcessingFeeRate: 0.18,
//       insuranceRate: 0.015,
//       stampDuty: 250,
//       invoiceCalculation: "GROSS_UP",
//       targetNetBank: 63540,
//       processingFeeRate: 0.02,
//       gstOnInsuranceRate: 0.18,
//       interestRate: 0.3,
//       eMandateCharge: 400,
//     },
//   },
// };

const emiAdminConfig = {
  minCIBIL: 500,
  tenures: [12],
  batteryTypes: ["52.2V/100AH Livguard"],
  downPayment: { min: 6500, max: 40000, step: 500 },
  updatedAt: new Date(),

  financiers: {
    AMU: {
      displayName: "AMU",
      invoiceFormula: "GROSS_UP",
      targetNetBank: 63540,
      interestRate: 0.3,
      emiRoundTo: 5,
      dpAdjustmentRate: 0.0236,
      invoiceDivisor: 0.9587,
      charges: [
        {
          key: "eMandateCharge",
          label: "E-Mandate",
          type: "fixed",
          value: 400,
          gstRate: 0,
        },
        {
          key: "loanSuraksha",
          label: "Loan Suraksha",
          type: "fixed",
          value: 850,
          gstRate: 0,
        },
        {
          key: "stampDuty",
          label: "Stamp Duty",
          type: "fixed",
          value: 250,
          gstRate: 0,
        },
        {
          key: "processingFee",
          label: "Processing Fee",
          type: "rate_on_loan",
          value: 0.02,
          gstRate: 0.18,
        },
        {
          key: "insurance",
          label: "Insurance",
          type: "rate_on_invoice",
          value: 0.015,
          gstRate: 0.18,
        },
      ],
      eligibility: {
        minCIBIL: 660,
        cities: [
          "INDORE",
          "UJJAIN",
          "BHOPAL",
          "JAIPUR",
          "GWALIOR",
          "KHATU",
          "GURGAON",
          "DABRA",
          "SHIVPURI",
          "FARIDABAD",
          "DEWAS",
        ],
        downPayment: { min: 8500, max: 16000 },
      },
      dpDisplayOverride: null,
    },

    MOOVING: {
      displayName: "MOOVING",
      invoiceFormula: "DIRECT",
      targetNetBank: 61145,
      interestRate: 0.4255,
      emiRoundTo: 5,
      charges: [],
      eligibility: {
        maxCIBIL: 659,
        cities: ["INDORE", "UJJAIN", "BHOPAL", "GWALIOR"],
        downPayment: { min: 12000, max: 12000 },
      },
      dpDisplayOverride: null,
    },

    LTO_LOW_CIBIL: {
      displayName: "LTO",
      invoiceFormula: "DIRECT",
      targetNetBank: 67440,
      interestRate: 0.45,
      emiRoundTo: 5,
      charges: [
        {
          key: "insurance",
          label: "Insurance",
          type: "rate_on_invoice",
          value: 0.015,
          gstRate: 0.18,
        },
      ],
      eligibility: {
        maxCIBIL: 659,
        cities: ["JAIPUR", "KHATU"],
        downPayment: { min: 12000, max: 40000 },
      },
      dpDisplayOverride: null,
    },

    LTO_HIGH_CIBIL: {
      displayName: "LTO",
      invoiceFormula: "DIRECT",
      targetNetBank: 67440,
      interestRate: 0.3,
      emiRoundTo: 5,
      charges: [
        {
          key: "insurance",
          label: "Insurance",
          type: "rate_on_invoice",
          value: 0.015,
          gstRate: 0.18,
        },
      ],
      eligibility: {
        minCIBIL: 660,
        cities: [
          "INDORE",
          "UJJAIN",
          "BHOPAL",
          "GWALIOR",
          "JAIPUR",
          "KHATU",
          "GURGAON",
          "DABRA",
          "SHIVPURI",
          "FARIDABAD",
          "DEWAS",
        ],
        downPayment: { min: 16500, max: 40000 },
      },
      dpDisplayOverride: null,
    },

    FINAYO_LOW_CIBIL: {
      displayName: "FINAYO",
      invoiceFormula: "FINAYO",
      targetNetBank: 63540,
      interestRate: 0.35,
      emiRoundTo: 5,
      charges: [
        {
          key: "technologyFee",
          label: "Technology Fee",
          type: "fixed",
          value: 1180,
          gstRate: 0,
        },
        {
          key: "processingFee",
          label: "Processing Fee",
          type: "fixed_amount",
          value: 2500,
          gstRate: 0.18,
        },
        {
          key: "insurance",
          label: "Insurance",
          type: "rate_on_invoice",
          value: 0.015,
          gstRate: 0.18,
        },
      ],
      eligibility: {
        minCIBIL: 650,
        maxCIBIL: 724,
        cities: ["INDORE", "UJJAIN", "BHOPAL", "GWALIOR"],
        downPayment: { min: 9000, max: 10000 },
      },
      dpDisplayOverride: {},
    },

    FINAYO_HIGH_CIBIL: {
      displayName: "FINAYO",
      invoiceFormula: "FINAYO",
      targetNetBank: 63540,
      interestRate: 0.35,
      emiRoundTo: 5,
      charges: [
        {
          key: "technologyFee",
          label: "Technology Fee",
          type: "fixed",
          value: 1180,
          gstRate: 0,
        },
        {
          key: "processingFee",
          label: "Processing Fee",
          type: "fixed_amount",
          value: 2500,
          gstRate: 0.18,
        },
        {
          key: "insurance",
          label: "Insurance",
          type: "rate_on_invoice",
          value: 0.015,
          gstRate: 0.18,
        },
      ],
      eligibility: {
        minCIBIL: 725,
        cities: ["INDORE", "UJJAIN", "BHOPAL", "GWALIOR"],
        downPayment: { min: 7000, max: 10000 },
      },
      dpDisplayOverride: {},
    },
  },
};

const fetchEmiAdminConfig = async (url) => {
  const response = await axios.get(url || endpoints.emiAdminConfig);
  // return emiAdminConfig;
  return response.data?.data || {};
};

export function useEmiAdminConfig(version = "v1") {
  let url = endpoints.getAdminEmiConfig;
  if (version === "v2") {
    url = endpoints.getAdminEmiConfigAllFinanciers;
  }

  return useQuery({
    queryKey: [`emi-admin-config-${version}`],
    queryFn: () => fetchEmiAdminConfig(url),
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
    retry: 1,
  });
}
